import PujaInfoView from "../../Views/Puja/PujaInfoView";
import ParentView from "../../Views/PrarentView/ParentView";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { pageReady } from "../../store/slices/pageViewSlice";
import {
  getTempleDetailsById,
  getTempleDetailsByNameKey,
  getBenefitsList,
} from "../../store/actions/templeAction";
import dayjs from "dayjs";
import {
  setSelectedPuja,
  setSelectedPujaDateAndTime,
  setSelectedTempleDetailsForPuja,
} from "../../store/slices/pujaSlice";
import {
  calculateDiscountedPrice,
  dayNameToNumber,
  getAvailableMonth,
  getDateFormatedForMUISelection,
  isSubscriptionAvailable,
  uid,
} from "../../utils/HelperFunctions";
import { updateTempCartPayloadAction } from "../../store/actions/cartAction";
import moment from "moment";
import { CouponService, truncateToTwoDecimals } from "td_server/services";
import {
  LOCALSTORAGE_KEY,
  metaTempleImg,
  orderType,
} from "../../utils/Constants";
import {
  getPriceInfoOfPujaAndPackageV1,
  getTopFivePujaFeedBack,
} from "../../store/actions/pujaAction";
import HelmetComponent from "../../components/Shared/HelmetComponent";
import { setSelectedTempleDetails } from "../../store/slices/templeSlice";
import { getDeviceTypeFromUserAgent } from "../../utils/analyics/analyticsHelper";

function PujaInfoScreen(props: any) {
  const location = useLocation();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const hasSubscriptionQueryApplied = useRef<boolean>(false);
  const [pujaDetails, setPujaDetails] = useState<any>(null);
  const [isDateTimePicker, setIsDateTimePicker] = useState(false);
  const [popupPujaAlreadyAdded, setPopupPujaAlreadyAdded] = useState(false);
  const [itemAddLimitPopUp, setItemAddLimitPopUp] = useState(false);
  const [pujaDateAndTime, setPujaDateAndTime] = useState({
    pujaDate: "",
    pujaTime: "10AM",
  });
  const [packageSelected, setPackageSelected]: any = useState(null);
  const [avialableCouponCode, setAvailableCouponCode] = useState(null);
  const [pujaPriceInfo, setPujaPriceInfo] = useState<any>(null);
  const [isSingleDatePujaEnabled, setIsSingleDatePujaEnabled] = useState(false);
  const [defaultCalendardate, setDefaultCalendardate] = useState<any>(null);
  const [userReview, setUserReview] = useState<any>([]);
  const [pujaSubscriptionPlans, setPujaSubscriptionPlans] = useState<any>([]);
  const [currentSubscriptionPlan, setCurrentSubscriptionPlan] =
    useState<any>(null);
  // state for subscription Button
  const [allowSubscription, setAllowSubscription] = useState<boolean>(false);
  const [isSubscriptionPresent, setIsSubscriptionPresent] =
    useState<boolean>(false);
  const [originalPrice, setOriginalPrice] = useState<any>(null);
  const handleSetPujaDateAndTime = (date: any) => {
    setPujaDateAndTime(date);
  };
  const { selectedTempleDetails, benefitsList } = useSelector(
    (state: any) => state.temple,
  );
  const [searchParams, setSearchParams] = useSearchParams();

  const { pujaVideos } = useSelector((state: any) => state.dashboard);

  const { cartInfo } = useSelector((state: any) => state.cart);
  const templeAndPujaInfoPath = location.pathname;
  const queryParams = new URLSearchParams(location.search);
  const templeNameKey = queryParams.get("templeNameKey");
  const pujaNameKey = queryParams.get("pujaNameKey");
  const priceConversionState = useSelector(
    (state: any) => state.priceConversion,
  );
  const {
    rate = 1,
    currencySymbols = "₹",
    isOverseas = false,
  } = priceConversionState.priceConversionRate || {};

  useEffect(() => {
    if (!pujaDetails) return;
    const subscriptionAvailable = isSubscriptionAvailable(
      pujaDetails?.pujaSubscription,
    );
    const urlWantsSubscription = searchParams.get("subscription") === "true";
    if (!subscriptionAvailable) {
      if (allowSubscription) {
        handleSubscriotionSwitch(false);
      }
      if (searchParams.has("subscription")) {
        const params = new URLSearchParams(searchParams);
        params.delete("subscription");
        setSearchParams(params, { replace: true });
      }
      return;
    }
    if (urlWantsSubscription !== allowSubscription) {
      handleSubscriotionSwitch(urlWantsSubscription);
      hasSubscriptionQueryApplied.current = true;
    }
  }, [pujaDetails?.pujaId]);

  useEffect(() => {
    if (!pujaDetails) return;
    const params = new URLSearchParams(searchParams);
    if (allowSubscription) {
      params.set("subscription", "true");
      hasSubscriptionQueryApplied.current = true;
    } else {
      params.delete("subscription");
      hasSubscriptionQueryApplied.current = false;
    }
    setSearchParams(params, { replace: true });
  }, [allowSubscription]);

  useEffect(() => {
    let keyType = props?.keyType;
    if (keyType && keyType === "id") {
      const templeIdComing = location.pathname.split("/")[2];
      dispatch(getTempleDetailsById(templeIdComing))
        .then((res: any) => {})
        .catch((err: any) => console.log("Error:", err));
    } else {
      const params = new URLSearchParams(location.search);
      let templeIdComing = params.get("templeNameKey");
      dispatch(getTempleDetailsByNameKey(templeIdComing))
        .then((res: any) => {
          if (typeof res === "undefined") {
            navigate("/temples");
          }
        })
        .catch((err: any) => console.log("Error:", err));
    }

    dispatch(getBenefitsList())
      .then((res: any) => {})
      .catch((err: any) => console.log("Error:", err));
    // }
    return () => {
      dispatch(setSelectedTempleDetails(null));
    };
  }, []);
  useEffect(() => {
    if (selectedTempleDetails?.nameKey) {
      dispatch(
        getTopFivePujaFeedBack(orderType?.puja, selectedTempleDetails?.nameKey),
      )
        .then((res: any) => {
          if (res) {
            setUserReview(res);
          }
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
  }, [selectedTempleDetails?.nameKey]);

  useEffect(() => {
    if (selectedTempleDetails) {
      const params = new URLSearchParams(location.search);
      const pujaListForTemple = selectedTempleDetails.templePuja;
      let keyType = props?.keyType;
      let selectedPujaDetails = null;
      if (keyType === "id") {
        const pujaId = templeAndPujaInfoPath.split("/")[4];
        selectedPujaDetails = pujaListForTemple.filter(function (item: any) {
          return item.pujaId === pujaId;
        });
      } else {
        const pujaId = params.get("pujaNameKey");
        selectedPujaDetails = pujaListForTemple?.filter(function (item: any) {
          return item.pujaNameKey === pujaId;
        });
      }

      if (selectedPujaDetails?.length > 0) {
        setPujaDetails(selectedPujaDetails[0]);
        detectAndSelectPackage(selectedPujaDetails[0]);
        if (isSubscriptionAvailable(selectedPujaDetails[0]?.pujaSubscription)) {
          setIsSubscriptionPresent(true);
          const filteredSubs =
            selectedPujaDetails[0]?.pujaSubscription?.subscriptions?.filter(
              (item: any) => item?.isSubscriptionEnabled,
            );
          setPujaSubscriptionPlans(filteredSubs);
          if (filteredSubs?.length) {
            setCurrentSubscriptionPlan(filteredSubs[0]);
          }
        }
      } else {
        // navigate("/temples");
      }
    }
  }, [selectedTempleDetails]);

  useEffect(() => {
    fetchCouponForPuja(selectedTempleDetails, pujaDetails, packageSelected);
  }, [selectedTempleDetails, pujaDetails, packageSelected]);

  const fetchCouponForPuja = async (
    selectedTempleDetails: any,
    pujaDetails: any,
    packageSelected: any,
  ) => {
    if (selectedTempleDetails && pujaDetails && !allowSubscription) {
      let response1 = await CouponService.getActiveCouponsByPujaIdCurrentDate(
        selectedTempleDetails?.id,
        pujaDetails?.pujaId,
        packageSelected?.packageId,
      );
      if (response1?.couponList && response1?.couponList?.length > 0) {
        setAvailableCouponCode(response1.couponList[0]);
      }
      // disable other coupons data
      // } else {
      //   try {
      //     let response3 = await CouponService.getAllActiveCouponsByDate();
      //     if (response3?.couponList && response3?.couponList?.length > 0) {
      //       setAvailableCouponCode(response3.couponList[0]);
      //     }
      //   } catch (error: any) {
      //     console.log("Error in coupon fetch", error);
      //   }
    }
  };

  const detectAndSelectPackage = (selectedPuja: any) => {
    if (
      selectedPuja?.multiplePujaDetails &&
      selectedPuja.multiplePujaDetails?.length > 0
    ) {
      let packages = selectedPuja?.multiplePujaDetails;
      let filterMostUsed = packages?.filter(
        (item: any) => item.isMostPopular === true,
      );
      if (filterMostUsed && filterMostUsed?.length > 0) {
        setPackageSelected(filterMostUsed[0]);
      } else {
        setPackageSelected(packages[0]);
      }
    }
    //Package data not present
    else {
    }
  };

  const [isSingleDatePuja, setIsSingleDatePuja] = useState(false);
  const checkSingleDatePuja = (): any => {
    if (!pujaDetails) {
      return false;
    }

    if (
      typeof pujaDetails?.restrictionDate === "undefined" ||
      pujaDetails?.restrictionDate?.length === 0
    ) {
      return false;
    }

    const validPujaDate: string[] = pujaDetails?.restrictionDate?.filter(
      (item: any) => Date.parse(item),
    );

    if (
      pujaDetails?.restrictionDate?.length === 1 &&
      validPujaDate?.length === 1
    ) {
      setIsSingleDatePuja(true);
      const targetPujaDate = moment(validPujaDate[0]);
      const twoDaysAfterTodayDate = moment().add(2, "day").format("YYYY-MM-DD");
      if (targetPujaDate.isAfter(twoDaysAfterTodayDate, "day")) {
        setIsSingleDatePujaEnabled(true);
        setPujaDateAndTime({
          pujaDate: new Date(validPujaDate[0])?.toDateString(),
          pujaTime: "10AM",
        });
      }
    } else {
      setIsSingleDatePuja(false);
    }
  };

  useEffect(() => {
    checkSingleDatePuja();
    if (
      typeof pujaDetails?.restrictionDate !== "undefined" &&
      pujaDetails?.restrictionDate?.length > 0
    ) {
      const pujaAvailableMonth = getAvailableMonth(
        pujaDetails?.restrictionDate,
      );
      if (pujaAvailableMonth > 0) {
        setDefaultCalendardate(dayjs().add(pujaAvailableMonth, "month"));
      }
    }
  }, [pujaDetails?.restrictionDate]);

  useEffect(() => {
    if (selectedTempleDetails && pujaDetails && packageSelected) {
      getPriceInfo(
        selectedTempleDetails?.id,
        pujaDetails.pujaId,
        packageSelected?.packageId,
      );
    } else if (selectedTempleDetails && pujaDetails) {
      getPriceInfo(selectedTempleDetails?.id, pujaDetails.pujaId, null);
    } else {
    }
  }, [
    selectedTempleDetails,
    pujaDetails,
    packageSelected,
    priceConversionState.priceConversionRate,
  ]);

  // useEffect(() => {
  //   if (selectedTempleDetails && pujaDetails && packageSelected) {
  //     getPriceInfo(
  //       selectedTempleDetails?.id,
  //       pujaDetails.pujaId,
  //       packageSelected?.packageId
  //     );
  //   } else if (selectedTempleDetails && pujaDetails) {
  //     getPriceInfo(selectedTempleDetails?.id, pujaDetails.pujaId, null);
  //   } else {
  //   }
  // }, [selectedTempleDetails, pujaDetails, packageSelected]);

  const [activeDate, setActiveDate] = useState<any>([]);

  const shouldDisableDate = (date: any): any => {
    if (!pujaDetails) {
      return false;
    }
    const selectedDate = dayjs();
    const twoDaysBeforeSelected = selectedDate.add(3, "day");
    if (
      typeof pujaDetails?.restrictionDate === "undefined" ||
      pujaDetails?.restrictionDate?.length === 0
    ) {
      if (date.isBefore(twoDaysBeforeSelected, "day")) {
        return true;
      } else {
        return false;
      }
    }

    const dayNames: string[] = pujaDetails?.restrictionDate?.filter(
      (item: any) => isNaN(Date.parse(item)),
    );

    if (date.isBefore(twoDaysBeforeSelected, "day")) {
      return true;
    }

    const specificDates: Date[] = pujaDetails?.restrictionDate
      ?.filter((item: any) => !isNaN(Date.parse(item)))
      ?.map((dateString: any) => new Date(dateString));

    // Convert day names to numbers
    const disableWeekDays: number[] = dayNames
      ?.map(dayNameToNumber)
      ?.filter((day) => day !== null) as number[];

    const day: number = date.day();
    if (disableWeekDays?.includes(day)) {
      return false;
    }

    return !specificDates?.some(
      (disabledDate) =>
        date?.date() === disabledDate?.getDate() &&
        date?.month() === disabledDate?.getMonth() &&
        date?.year() === disabledDate?.getFullYear(),
    );
  };

  const preprocessingAndProceedToAddmemberScreen = async () => {
    // Open pupup for limiting popup and return from there
    if (
      (cartInfo && cartInfo.length === 6) ||
      (cartInfo && cartInfo.length > 6)
    ) {
      setItemAddLimitPopUp(true);
      return;
    }

    if (isSubscriptionPresent && allowSubscription) {
      dispatch(setSelectedTempleDetailsForPuja(selectedTempleDetails));
      dispatch(setSelectedPuja(pujaDetails));
      const id = uid();
      let cartDataPayload: any = {
        id: id,
        cartId: id,
        membersData: [],
        pujaDetails: pujaDetails,
        templeDetails: selectedTempleDetails,
        pujaDateTime: null,
        bookedForDate: null,
        selectedPujaPackage: packageSelected,
        orderType: orderType.puja,
        currentSubscriptionPlan: currentSubscriptionPlan,
        isSubscribed: true,
        subscriptionId: currentSubscriptionPlan?.subscriptionId,
        tempPriceInfo: {
          finalPrice: pujaPriceInfo?.finalPrice},
      };
      dispatch(updateTempCartPayloadAction(cartDataPayload)).then(() => {
        navigate(`/checkoutV2/addDevotee`);
      });
      return;
    }

    // if(userInfo?.phoneNumber){
    //   await CartService.clearCart(userInfo?.phoneNumber)
    // }

    if (pujaDateAndTime.pujaDate) {
      dispatch(setSelectedTempleDetailsForPuja(selectedTempleDetails));
      dispatch(setSelectedPuja(pujaDetails));
      //Setting all puja date to 10 AM
      const formattedDateToSave = getDateFormatedForMUISelection(
        pujaDateAndTime.pujaDate?.toString(),
      );
      let dateTimeData = {
        pujaDate: formattedDateToSave,
        // pujaDate: "2025-03-09 10:30AM",
        pujaTime: "10:30AM",
      };
      dispatch(setSelectedPujaDateAndTime(dateTimeData));
      const id = uid();
      let cartDataPayload: any = {
        id: id,
        cartId: id,
        membersData: [],
        pujaDetails: pujaDetails,
        templeDetails: selectedTempleDetails,
        pujaDateTime: dateTimeData,
        bookedForDate: dateTimeData,
        selectedPujaPackage: packageSelected,
        orderType: orderType.puja,
        tempPriceInfo: pujaPriceInfo,
      };

      // let newCartData = cartInfo && cartInfo?.length > 0 ? [...cartInfo] : [] ;
      // newCartData.push(cartDataPayload);

      // if(userInfo?.phoneNumber){
      //   await CartService.addToCart(userInfo?.phoneNumber,cartDataPayload)
      // }
      // dispatch(updateCartAction(newCartData)).then(()=>{
      //   navigate(`/checkoutV2/addDevotee?cartId=${cartDataPayload.cartId}`);
      // });
      dispatch(updateTempCartPayloadAction(cartDataPayload)).then(() => {
        navigate(`/checkoutV2/addDevotee`);
      });
    } else {
    }
  };

  const getPriceInfo = async (templeId: any, pujaId: any, packageId: any) => {
    try {
      dispatch(
        getPriceInfoOfPujaAndPackageV1(
          pujaDetails,
          templeId,
          packageId,
          isOverseas,
        ),
      )
        .then((response: any) => {
          // storing original Price
          setOriginalPrice(response);
          if (
            currentSubscriptionPlan?.subscriptionId &&
            hasSubscriptionQueryApplied.current
          ) {
            const _offerActualPrice =
              response?.finalPrice * Number(currentSubscriptionPlan?.frequency);
            const _finalPrice = truncateToTwoDecimals(
              calculateDiscountedPrice(
                _offerActualPrice,
                Number(currentSubscriptionPlan?.fixDiscount),
              ),
            );
            setPujaPriceInfo({
              ...response,
              finalPrice: _finalPrice,
              offerActualPrice: truncateToTwoDecimals(_offerActualPrice),
            });
            return;
          }
          setPujaPriceInfo(response);
        })
        .catch((error: any) => {
          console.log("Error:", error);
        });
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const navigateToPujaStepsView = () => {
    navigate(
      `/pujaSteps?templeNameKey=${templeNameKey}&pujaNameKey=${pujaNameKey}`,
    );
  };

  const navigateToSeeVideoView = () => {
    navigate("/pujaVideo");
  };

  useEffect(() => {
    if (!pujaDetails?.id || !selectedTempleDetails?.id || !pujaPriceInfo?.finalPrice ) return;

    const userInfo = JSON.parse(
      localStorage.getItem(LOCALSTORAGE_KEY.USERINFO) ?? "{}",
    );
    const basePrice =
      originalPrice?.finalPrice ?? pujaPriceInfo?.finalPrice ?? 0;

    dispatch(
      pageReady({
        User_ID: userInfo?.id ?? "Guest User",
        Puja_ID: pujaDetails?.pujaId ?? "",
        Puja_Name: pujaDetails?.pujaName ?? "",
        Puja_Category: pujaDetails?.pujaSubCategory?.[0]?.name ?? "",
        Temple_ID: selectedTempleDetails?.id ?? "",
        Temple_Name: selectedTempleDetails?.personalInfo?.name ?? "",
        Temple_NameKey: selectedTempleDetails?.nameKey ?? "",
        Base_Price: truncateToTwoDecimals(basePrice),
        Currency: currencySymbols,
        IsOverseas: isOverseas,
        rate: rate,
        IsPrasad: true,
        Deity: pujaDetails?.personalInfo?.name ?? "",
        Purpose: pujaDetails?.pujaSubCategory?.[0]?.name ?? "",
        Page_Type: "Puja detail",
        Device_Type: getDeviceTypeFromUserAgent(),
        Platform: getDeviceTypeFromUserAgent(),
      }),
    );
  }, [
    pujaDetails?.id,
    selectedTempleDetails?.id,
    pujaPriceInfo,
  ]);

  const hostname =
    window.location.hostname === "localhost"
      ? "http://localhost:3000"
      : "https://" + window.location.hostname;

  const handleSubscriotionSwitch = (isEnabled: boolean) => {
    const y = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (isEnabled && currentSubscriptionPlan?.subscriptionId) {
      const _offerActualPrice =
        originalPrice?.finalPrice * Number(currentSubscriptionPlan?.frequency);

      const _finalPrice = truncateToTwoDecimals(
        calculateDiscountedPrice(
          _offerActualPrice,
          Number(currentSubscriptionPlan?.fixDiscount),
        ),
      );
      setPujaPriceInfo({
        ...originalPrice,
        finalPrice: _finalPrice,
        offerActualPrice: truncateToTwoDecimals(_offerActualPrice),
      });
    } else {
      setPujaPriceInfo(originalPrice);
    }
    setAllowSubscription(isEnabled);
    setTimeout(() => {
      window.scrollTo(0, y);
    }, 50);
  };

  const handleSelectPujaSubscription = (subscriptionPlan: any) => {
    if (!allowSubscription && subscriptionPlan?.subscriptionId) return;

    const _offerActualPrice =
      originalPrice?.finalPrice * Number(subscriptionPlan?.frequency);
    const _finalPrice = truncateToTwoDecimals(
      calculateDiscountedPrice(
        _offerActualPrice,
        Number(subscriptionPlan?.fixDiscount),
      ),
    );
    setPujaPriceInfo({
      ...originalPrice,
      finalPrice: _finalPrice,
      offerActualPrice: truncateToTwoDecimals(_offerActualPrice),
    });

    setCurrentSubscriptionPlan(subscriptionPlan);
  };

  return (
    <ParentView>
      <HelmetComponent
        metaData={{
          title:
            pujaDetails?.pujaMetaData?.metaTitle ??
            pujaDetails?.pujaName ??
            "Temple" + " | TempleDekho",
          keywords: pujaDetails?.pujaMetaData?.metaKeys ?? null,
          robots: "index, follow",
          description:
            pujaDetails?.pujaMetaData?.metaDescription ??
            pujaDetails?.pujaDescription,
          url: hostname + templeAndPujaInfoPath,
          imageUrl: pujaDetails?.pujaBg?.uri ?? metaTempleImg,
        }}
      >
        <PujaInfoView
          cartInfo={cartInfo}
          pujaDetails={pujaDetails}
          shouldDisableDate={shouldDisableDate}
          selectedTempleDetails={selectedTempleDetails}
          preprocessingAndProceedToAddmemberScreen={
            preprocessingAndProceedToAddmemberScreen
          }
          isSingleDatePuja={isSingleDatePuja}
          benefitsList={benefitsList}
          setIsDateTimePicker={setIsDateTimePicker}
          isDateTimePicker={isDateTimePicker}
          pujaDateAndTime={pujaDateAndTime}
          setPujaDateAndTime={handleSetPujaDateAndTime}
          popupPujaAlreadyAdded={popupPujaAlreadyAdded}
          setPopupPujaAlreadyAdded={setPopupPujaAlreadyAdded}
          packageSelected={packageSelected}
          setPackageSelected={setPackageSelected}
          navigateToPujaStepsView={navigateToPujaStepsView}
          navigateToSeeVideoView={navigateToSeeVideoView}
          avialableCouponCode={avialableCouponCode}
          pujaPriceInfo={pujaPriceInfo}
          isSingleDatePujaEnabled={isSingleDatePujaEnabled}
          overSeasRate={rate}
          currencySymbols={currencySymbols}
          isOverseas={isOverseas}
          isCountryDisabledForBooking={
            priceConversionState?.isCountryDisabled ?? false
          }
          defaultCalendardate={defaultCalendardate}
          setDefaultCalendardate={setDefaultCalendardate}
          userReview={userReview}
          itemAddLimitPopUp={itemAddLimitPopUp}
          setItemAddLimitPopUp={setItemAddLimitPopUp}
          pujaPreviewVideos={pujaVideos || []}
          allowSubscription={allowSubscription}
          handleSubscriotionSwitch={handleSubscriotionSwitch}
          handleSelectPujaSubscription={handleSelectPujaSubscription}
          pujaSubscriptionPlans={pujaSubscriptionPlans}
          currentSubscriptionPlan={currentSubscriptionPlan}
          isSubscriptionPresent={isSubscriptionPresent}
          originalPrice={originalPrice}
        />
      </HelmetComponent>
    </ParentView>
  );
}

export default PujaInfoScreen;
